// React
import { FC, useState } from 'react'

// Libraries
import { Link } from 'gatsby-plugin-react-i18next'

// Custom
import { Wrapper, Container, MenuContainer, NavBar } from './styled'
import { Logo } from 'components/UI/Images'
import { theme } from 'lib/styled-components/theme'
import { PaddingContainer } from 'components/UI/Containers'
import Hamburger from 'components/UI/Buttons/Hamburger'
import LanguageSwitcher from 'components/LanguageSwitcher'
import NavMenu from 'components/NavMenu'
import useMediaQuery from 'hooks/useMediaQuery'

type Option = {
  label: string
  path: string
}

type Props = {
  navOptions?: Option[]
}

const Header: FC<Props> = ({ navOptions }: Props) => {
  const [showMenu, setShowMenu] = useState(false)
  const isDesktop = useMediaQuery(
    `(min-width: ${theme.breakpoints.desktopMin}px)`,
  )

  const toggleShowMenu = () => {
    setShowMenu((prev: boolean) => !prev)
  }

  return isDesktop ? (
    <Wrapper>
      <PaddingContainer>
        <Container>
          <Link to="/">
            <Logo dark={true} />
          </Link>
          <NavBar data-testid="navbar">
            <NavMenu navOptions={navOptions} />
          </NavBar>
          <LanguageSwitcher />
        </Container>
      </PaddingContainer>
    </Wrapper>
  ) : (
    <Wrapper>
      <PaddingContainer>
        <Container>
          <Link to="/">
            <Logo dark={true} />
          </Link>
          <Hamburger onClick={toggleShowMenu} active={showMenu} />
        </Container>
      </PaddingContainer>
      <MenuContainer active={showMenu} onClick={toggleShowMenu}>
        <NavBar data-testid="navbar">
          <NavMenu navOptions={navOptions} />
        </NavBar>
        <LanguageSwitcher />
      </MenuContainer>
    </Wrapper>
  )
}

export default Header
